import mrpStyles from './../mrp.json'

export default {
  default: {
    backgroundColor: mrpStyles.colors.PrimaryBlack,
    border: `1px solid ${mrpStyles.colors.PrimaryBlack}`,
    color: mrpStyles.colors.PrimaryWhite
  },
  inverse: {
    backgroundColor: mrpStyles.colors.PrimaryWhite,
    border: `1px solid ${mrpStyles.colors.PrimaryBlack}`,
    color: mrpStyles.colors.PrimaryBlack
  },
  disabled: {
    color: mrpStyles.colors.SecondaryGreySky,
    backgroundColor: mrpStyles.colors.PrimaryWhite,
    border: `1px solid ${mrpStyles.colors.PrimaryGrey}`
  },
  hover: {
    backgroundColor: mrpStyles.colors.SecondaryGreyMetal,
    border: `1px solid ${mrpStyles.colors.SecondaryGreyMetal}`
  },
  hoverInverse: {
    backgroundColor: mrpStyles.colors.PrimaryGrey,
    border: `1px solid ${mrpStyles.colors.PrimaryGrey}`
  }
}
